import { Formik } from "formik";
import { useEffect } from "react";
import Loader from "../../../loader";
import "react-phone-number-input/style.css";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../../form/ErrorMessage";
import { coachPaths } from "../../../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { becomeCoachSchema } from "../../../../utils/schema";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

import {
  fetchCoachCategories,
  handleCoachSignUp,
} from "../../../../redux/features/coach/actions/authAction";

const BecomeCoachModal = ({ isOpen, setClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categoryList, isLoading } = useSelector((state) => state.coach.auth);

  const normalizePhoneValue = (value) => {
    if (!value) return "";
    const trimmed = String(value).trim();
    if (!trimmed) return "";
    if (trimmed.startsWith("+")) return trimmed;
    const digits = trimmed.replace(/\D/g, "");
    if (!digits) return "";
    return `+${digits}`;
  };

  const initialState = {
    full_name: "",
    email: "",
    phone_number: "",
    category_id: "",
    format: "",
    tagline: "",
    bio: "",
    reason: "",
    year_of_experience: "",
    profile_image: "",
    cv: "",
    certificate: "",
  };

  const handleBecomeCoachDetails = (values) => {
    const formData = new FormData();
    formData.append("year_of_experience", parseInt(values.year_of_experience));
    formData.append("profile_image", values?.profile_image);
    formData.append("phone_number", values.phone_number);
    formData.append("certificate", values?.certificate);
    formData.append("category_id", values.category_id);
    formData.append("full_name", values.full_name);
    formData.append("tagline", values?.tagline);
    formData.append("format", values.format);
    formData.append("reason", values?.reason);
    formData.append("email", values.email);
    formData.append("bio", values?.bio);
    formData.append("cv", values?.cv);
    const callback = (response) => {
      if (response) {
        // navigate(coachPaths?.Login);
        setClose(false);
      }
    };
    dispatch(handleCoachSignUp({ payload: formData, callback }));
  };

  useEffect(() => {
    dispatch(fetchCoachCategories());
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.position = "relative";
    };
  }, [isOpen]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div
        className="modal fade modal-xl d-block show  "
        id="ct_claim_your_spot"
        tabindex="-1"
        aria-labelledby="ct_claim_your_spotLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                onClick={() => {
                  setClose(false);
                }}
                className="btn-close ct_close_position_right12"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0">
                    <h4 className="ct_fs_32 mb-3">Tell Us About You</h4>
                    <p className="ct_fs_20" style={{ maxWidth: "612px" }}>
                      We’ll use this information to{" "}
                      <span className="ct_darksky_blue_text">evaluate</span>{" "}
                      your profile and match you with the right opportunities.
                    </p>
                    <Formik
                      initialValues={initialState}
                      validationSchema={becomeCoachSchema}
                      onSubmit={(values, actions) => {
                        handleBecomeCoachDetails(values);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        setFieldError,
                        setTouched,
                      }) => (
                        <form action={handleSubmit} className="ct_mt_60">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label for="" className="d-block mb-2 ct_fs_14">
                                  Full Name
                                </label>
                                <input
                                  type="text"
                                  placeholder="Full Name"
                                  className="form-control ct_input ct_input_h_60 ct_fs_14"
                                  id="full_name"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.full_name}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="full_name"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="d-block mb-2 ct_fs_14">
                                  Email Address
                                </label>
                                <input
                                  type="email"
                                  placeholder="Email address"
                                  className="form-control ct_input ct_input_h_60 ct_fs_14"
                                  id="email"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.email}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="email"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label for="" className="d-block mb-2 ct_fs_14">
                                  Phone Number
                                </label>
                                <PhoneInput
                                  id="phone_number"
                                  className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60 "
                                  defaultCountry="MU"
                                  value={normalizePhoneValue(values?.phone_number)}
                                  onChange={(val) => {
                                    const safeVal = val ?? "";
                                    if (
                                      typeof safeVal === "string" &&
                                      safeVal.length > 2 &&
                                      isValidPhoneNumber(safeVal)
                                    ) {
                                      setFieldValue("phone_number", safeVal);
                                    } else if (!isValidPhoneNumber(safeVal)) {
                                      setFieldError(
                                        "phone_number",
                                        "Please enter valid phone number"
                                      );
                                      setFieldValue("phone_number", safeVal);
                                    }
                                  }}
                                  onBlur={handleBlur}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="phone_number"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label for="" className="d-block mb-2 ct_fs_14">
                                  Coaching Category
                                </label>
                                <div className="d-flex flex-column gap-2 position-relative">
                                  <select
                                    className="form-control ct_input ct_input_h_60 ct_fs_14"
                                    id="category_id"
                                    name="category_id"
                                    value={values?.category_id}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  >
                                    <option value={""}>
                                      Select Coaching Category
                                    </option>
                                    ;
                                    {categoryList?.map((item, ind) => {
                                      return (
                                        <option value={item?.category_id}>
                                          {item?.category_name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <i className="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"category_id"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label for="" className="d-block mb-2 ct_fs_14">
                                  Year of Experience
                                </label>
                                <input
                                  type="text"
                                  className="form-control ct_input ct_fs_14 ct_input_h_60"
                                  placeholder="Years of Experience "
                                  id="year_of_experience"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.year_of_experience}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="year_of_experience"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label
                                  for=""
                                  className="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Coaching Format
                                </label>
                                <div className="d-flex flex-column gap-2 position-relative">
                                  <select
                                    name="format"
                                    id="format"
                                    value={values?.format}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="form-control ct_input ct_fs_14 ct_input_h_60"
                                  >
                                    <option value={""}>
                                      Select Coaching Format
                                    </option>
                                    {[
                                      { label: "1:1", val: "1:1" },
                                      { label: "Group", val: "GROUP" },
                                      { label: "Both", val: "BOTH" },
                                    ]?.map((item, ind) => {
                                      return (
                                        <option value={item?.val}>
                                          {item?.label}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <i className="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"format"}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label for="" className="d-block mb-2 ct_fs_14">
                                  Bio
                                </label>
                                <textarea
                                  className="form-control ct_input h-auto ct_fs_14"
                                  rows="4"
                                  id="bio"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.bio}
                                ></textarea>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"bio"}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label
                                  for=""
                                  className="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  Taglines
                                </label>
                                <textarea
                                  type="text"
                                  className="form-control ct_input h-auto ct_fs_14"
                                  placeholder="short and impactful"
                                  rows={3}
                                  id="tagline"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.tagline}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"tagline"}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label
                                  for=""
                                  className="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  {" "}
                                  Profile Photo{" "}
                                </label>
                                <div className="ct_upload_product_main ct_upload_product_main_180 ">
                                  <label>
                                    <p className="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer d-flex align-items-center gap-2">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                          fill="#023047"
                                        ></path>
                                      </svg>
                                      Upload Profile
                                    </p>
                                    <input
                                      type="file"
                                      name=""
                                      id="profile_image"
                                      accept="image/*"
                                      onChange={(event) => {
                                        const file =
                                          event.currentTarget.files[0];
                                        setTouched({ profile_image: true });
                                        setFieldValue("profile_image", file);
                                      }}
                                      onBlur={handleBlur}
                                      className="d-none"
                                    />
                                  </label>
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"profile_image"}
                                />
                                {values?.profile_image && (
                                  <div className="ct_single_uploaded_img mt-3 ">
                                    <img
                                      src={
                                        values?.profile_image
                                          ? typeof values.profile_image ===
                                            "string"
                                            ? values.profile_image
                                            : URL.createObjectURL(
                                              values.profile_image
                                            )
                                          : ""
                                      }
                                      alt=""
                                    />
                                    <i
                                      className="fa-solid fa-xmark"
                                      onClick={() => {
                                        setTouched({ profile_image: true });
                                        setFieldValue("profile_image", null);
                                      }}
                                    ></i>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label className="mb-2 d-block ct_darkblue_text ct_fs_14">
                                  {" "}
                                  CV{" "}
                                </label>
                                <div className="ct_upload_product_main ct_upload_product_main_180 ">
                                  <label>
                                    <p className="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer d-flex align-items-center gap-2">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                          fill="#023047"
                                        ></path>
                                      </svg>
                                      Upload CV
                                    </p>
                                    <input
                                      type="file"
                                      name=""
                                      id="cv"
                                      accept="image/*"
                                      onChange={(event) => {
                                        const file =
                                          event.currentTarget.files[0];
                                        setTouched({ cv: true });
                                        setFieldValue("cv", file);
                                      }}
                                      onBlur={handleBlur}
                                      className="d-none"
                                    />
                                  </label>
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"cv"}
                                />
                                {values?.cv && (
                                  <div className="ct_single_uploaded_img mt-3 ">
                                    <img
                                      src={
                                        values?.cv
                                          ? typeof values.cv === "string"
                                            ? values.cv
                                            : URL.createObjectURL(values.cv)
                                          : ""
                                      }
                                      alt=""
                                    />
                                    <i
                                      className="fa-solid fa-xmark"
                                      onClick={() => {
                                        setTouched({ cv: true });
                                        setFieldValue("cv", null);
                                      }}
                                    ></i>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label
                                  for=""
                                  className="mb-2 d-block ct_darkblue_text ct_fs_14"
                                >
                                  {" "}
                                  Certificate{" "}
                                </label>
                                <div className="ct_upload_product_main ct_upload_product_main_180 ">
                                  <label>
                                    <p className="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer d-flex align-items-center gap-2">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                          fill="#023047"
                                        ></path>
                                      </svg>
                                      Upload Certificate
                                    </p>
                                    <input
                                      type="file"
                                      id="certificate"
                                      accept="image/*"
                                      onChange={(event) => {
                                        const file =
                                          event.currentTarget.files[0];
                                        setTouched({ certificate: true });
                                        setFieldValue("certificate", file);
                                      }}
                                      onBlur={handleBlur}
                                      className="d-none"
                                    />
                                  </label>
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"certificate"}
                                />
                                {values?.certificate && (
                                  <div className="ct_single_uploaded_img mt-3 ">
                                    <img
                                      src={
                                        values?.certificate
                                          ? typeof values.certificate ===
                                            "string"
                                            ? values.certificate
                                            : URL.createObjectURL(
                                              values.certificate
                                            )
                                          : ""
                                      }
                                      alt=""
                                    />
                                    <i
                                      className="fa-solid fa-xmark"
                                      onClick={() => {
                                        setTouched({ certificate: true });
                                        setFieldValue("certificate", null);
                                      }}
                                    ></i>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-3">
                                <label for="" className="d-block mb-2 ct_fs_14">
                                  Why do you want to join NUVIO as a coach?
                                </label>
                                <textarea
                                  className="form-control ct_input h-auto ct_fs_14"
                                  rows="4"
                                  id="reason"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.reason}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"reason"}
                                />
                              </div>
                            </div>
                            <p
                              className="ct_fs_18"
                              style={{ maxWidth: "650px" }}
                            >
                              Thanks for having an interest in joining our
                              coaching platform! Our team will review the
                              details and get back to you.
                            </p>
                          </div>

                          <div className="text-end mt-5">
                            <button
                              type="button"
                              className="ct_yellow_btn  px-5 ms-auto"
                              onClick={handleSubmit}
                            // data-bs-toggle="modal" data-bs-target="#ct_submit_modal"
                            >
                              {" "}
                              Submit My Application
                            </button>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                  <div className="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0  ps-lg-5">
                    <div className="ct_need_help_card">
                      <h4 className="ct_fs_24 mb-3">
                        Need Help Filling This Form?
                      </h4>
                      <ul>
                        <li className="ct_fs_18 ">
                          Use a clear, specific job title that reflects the role
                          and level skip vague or trendy terms.
                        </li>
                        <li className="ct_fs_18">
                          Describe what makes the role exciting or unique to
                          help your post stand out.
                        </li>
                        <li className="ct_fs_18">
                          List the main responsibilities, skills required, and
                          what success looks like.
                        </li>
                        <li className="ct_fs_18">
                          Specify if the job is remote, hybrid, or onsite to
                          manage expectations from the start.
                        </li>
                      </ul>
                      <p className="ct_fs_18 mt-4">
                        Need help{" "}
                        <span className="ct_yellow_text">Contact Us</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BecomeCoachModal;
